import { Skeleton } from '../../../../../components/Generic';

const LoadingComponent = () => (
  <>
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
    <Skeleton
      style={{
        height: 60,
        width: '100%',
        borderRadius: 8,
        marginTop: 20,
      }}
    />
  </>
);

export default LoadingComponent;
